<template>
  <div class="tq-person-selector-card">
    <div class="tq-person-selector-card-bg">
      <p class="tq-person-selector-card-name">
        {{ person.personName }} - {{ person.personCode }}
      </p>
      <p class="tq-person-selector-card-position">
        {{ person.positionName }}
      </p>
      <el-tooltip
        placement="top"
        effect="dark"
        :show-after="500"
        :content="person.personHierarchy"
      >
        <p class="tq-person-selector-card-hierarchy">
          {{ person.personHierarchy }}
        </p>
      </el-tooltip>
    </div>
    <div
      class="tq-person-selector-card-btn"
      @click="emits('remove', person.personCode)"
    ></div>
  </div>
</template>

<script lang="ts" setup>
import type { PersonSelector } from "../types/index";
defineProps<{ person: PersonSelector.PersonList }>();

const emits = defineEmits(["remove"]);
</script>
